const getMWStName = (codeMWSt, t) => {
	switch (codeMWSt) {
		case 'free':
			return t('closing_section.fields.vat_free')
		case 'normal':
			return t('closing_section.fields.vat_normal')
		case 'reduced':
			return t('closing_section.fields.vat_reduced')
		case 'special':
			return t('closing_section.fields.vat_special')
		default:
			return codeMWSt
	}
}

export default getMWStName
